import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from '@heroicons/react/24/solid';
import { useNavigate } from 'react-router-dom';
import AppHeader from '../components/AppHeader';
import AppFooter from '../components/AppFooter';

const BillingCancel: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50">
      <AppHeader />
      <main className="max-w-3xl mx-auto px-6 py-16 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div className="flex justify-center mb-6">
            <XCircleIcon className="w-16 h-16 text-rose-500" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-3">Checkout canceled</h1>
          <p className="text-gray-600 mb-8">No worries—your card wasn’t charged. You can try again any time from your dashboard.</p>
          <button
            onClick={() => navigate('/dashboard')}
            className="px-6 py-3 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            Back to dashboard
          </button>
        </motion.div>
      </main>
      <AppFooter />
    </div>
  );
};

export default BillingCancel;


